import { Box, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { customValue } from "../../../utils/colorVariable";
import { getWarehouseUrl } from "../../../utils/urlStorage";

interface ICustomItem {
  label: string;
  isActive?: boolean;
  onClick: (label: string) => void;
  subMenu?: Array<{ label: string; link: string; directLink?: boolean }>;
  link?: string;
  suffix?: boolean;
}

export const CustomItem: React.FC<ICustomItem> = ({
  label,
  onClick,
  subMenu,
  suffix,
}) => {
  const { pathname } = useLocation();
  const [currentWarehouseUrl, setCurrentWarehouseUrl] = useState(getWarehouseUrl());
  const isItemActive = useCallback(
    (link: string) => pathname === link || pathname.startsWith(link + "/"),
    [pathname]
  );
  const handleClick = useCallback(() => {
    setCurrentWarehouseUrl(getWarehouseUrl()); 
    onClick(label);
  }, [label, onClick]);

  return (
    <Box
      onClick={handleClick}
      sx={{
        width: "100%",
        padding: 1,
        borderRadius: customValue.borderRadius,
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: "bold",
        }}
      >
        {label}
      </Typography>
      {subMenu &&
        subMenu.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
              width: "auto",
            }}
          >
            {item.directLink ? (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "#5E686D" }}
              >
                <Typography
                  sx={{
                    cursor: "pointer",
                    color: "inherit",
                    textDecoration: isItemActive(item.link) ? "underline" : "",
                    ":hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  {item.label}
                </Typography>
              </a>
            ) : (
              <Link
                to={item.link + (suffix ? currentWarehouseUrl : "")}
                style={{ textDecoration: "none", color: "#5E686D" }}
              >
                <Typography
                  sx={{
                    cursor: "pointer",
                    textDecoration: isItemActive(item.link + (suffix ? currentWarehouseUrl : "")) ? "underline" : "",
                    ":hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                {item.label}
                </Typography>
              </Link>
            )}
          </Box>
        ))}
    </Box>
  );
};
